import { defineStore } from 'pinia'

interface MenuState {
  maxVisibleLevel: number;
  expandedItems: Set<string>;
  visibleLevel: number;
}

export const useMenuStore = defineStore('menu', {
  state: (): MenuState => ({
    maxVisibleLevel: 5,
    expandedItems: new Set<string>(),
    visibleLevel: 5
  }),
  
  actions: {
    toggleExpand(id: string) {
      if (this.expandedItems.has(id)) {
        this.expandedItems.delete(id)
      } else {
        this.expandedItems.add(id)
      }
    },
    
    setVisibleLevel(level: number) {
      this.visibleLevel = Math.min(Math.max(1, level), this.maxVisibleLevel)
    }
  }
}) 